import React from 'react';
import { Coins } from 'lucide-react';

export default function Login() {
  const startLogin = () => {
    window.location.href = `${process.env.REACT_APP_BACKEND_URL}/api/auth/google/login`;
  };

  return (
    <div className="min-h-screen bg-[#F6F6F4] flex items-center justify-center px-6" data-testid="login-page">
      <div className="w-full max-w-md bg-white border border-border p-10 shadow-[0_8px_32px_rgba(0,0,0,0.04)]">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 bg-[hsl(var(--primary))] flex items-center justify-center">
            <Coins size={22} strokeWidth={2.25} className="text-white" />
          </div>
          <div>
            <div className="font-heading font-bold text-[20px] tracking-tight leading-none">Track</div>
            <div className="overline mt-1 leading-none text-[10px]">Personal&nbsp;Wealth</div>
          </div>
        </div>
        <h1 className="font-heading font-bold text-[28px] tracking-tight mb-2">Welcome back</h1>
        <p className="text-[#575757] text-sm mb-8 leading-relaxed">
          Sign in with Google to access your private portfolio. Your data is scoped to your account and persists across devices.
        </p>
        <button
          onClick={startLogin}
          data-testid="google-login-button"
          className="w-full bg-white border border-[#1A3626] text-[#1A3626] hover:bg-[#1A3626] hover:text-white font-heading font-semibold text-[14px] py-3 px-4 rounded-sm flex items-center justify-center gap-3 transition-colors"
        >
          <svg width="18" height="18" viewBox="0 0 18 18">
            <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"/>
            <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z"/>
            <path fill="#FBBC05" d="M3.964 10.71c-.18-.54-.282-1.117-.282-1.71s.102-1.17.282-1.71V4.958H.957C.347 6.173 0 7.548 0 9s.348 2.827.957 4.042l3.007-2.332z"/>
            <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.958l3.007 2.332C4.672 5.163 6.656 3.58 9 3.58z"/>
          </svg>
          Continue with Google
        </button>
        <div className="mt-8 border-t border-border pt-5 text-[11px] font-mono text-[#787872] leading-relaxed">
          v1.0 · Personal use only<br/>
          Data is private and scoped per Google account.
        </div>
      </div>
    </div>
  );
}
